import React from 'react';
import { Message } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';
import OnboardingLayout from './OnboardingLayout';

const OnboardingRolePlaceholder = ({ roleName }) => {
  const { t } = useTranslation('onboarding');
  const roleLabel = t(`rolePlaceholder.roles.${roleName}`, { defaultValue: '' }) || t('rolePlaceholder.thisRole');

  return (
    <OnboardingLayout
      currentStep={1}
      totalSteps={1}
      stepTitle={t('wizard.underConstruction')}
    >
      <div className="onboarding-wizard">
        <div className="wizard-content">
          <Message
            type="warning"
            content={t('rolePlaceholder.notAvailable', { role: roleLabel })}
          />
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingRolePlaceholder;
